import React, { useState } from 'react';
import { Button, Tooltip, Row, Col } from 'antd';
import copy from 'copy-to-clipboard';

const DashboardTrackingList = () => {
	const [visible, setvisible] = useState(false);
	const handleCopy = () => {
		setvisible(true);
		copy('https://konnektive.com/resources_type/affiliate-world-asia/=&C0FDBA1&c1=[c1]&c2=[c2]&[c3]=[c3]');
		setTimeout(() => {
			setvisible(false);
		}, 1000);
	};

	return (
		<Row className="tracking_packs_column">
			<Col xl={4} lg={24} md={24} sm={24} xs={24} className="col_name" style={{ marginTop: '5px' }}>
				Tracking Pixels 1
			</Col>
			<Col xl={16} lg={20} md={24} sm={24} xs={24} style={{ marginTop: '5px' }}>
				<Tooltip placement="top" color="#EB8601" visible={visible} title={'Link copied'}>
					<div className="link_area">
						<div className="left_bor"></div>
						<div className="content">https://konnektive.com/resources_type/affiliate-world-asia/=&C0FDBA1&c1=[c1]&c2=[c2]&[c3]=[c3]</div>
					</div>
				</Tooltip>
			</Col>
			<Col xl={4} lg={4} md={24} sm={24} xs={24} style={{ textAlign: 'center', marginTop: '5px' }}>
				<Button onClick={handleCopy} className="col-butn" htmlType="submit">
					Copy
				</Button>
			</Col>
		</Row>
	);
};

export default DashboardTrackingList;
